import { createRequestCoordinator } from "../core/request-coordinator.js";

export function createTurnDetailState() {
  return {
    turn: null,
    turnDiagnostics: null,
    workspaceDiagnostics: null,
    events: [],
    eventSeqs: new Set(),
    artifacts: [],
    decisions: [],
    selectedArtifactID: "",
    artifactBody: "",
    artifactError: "",
    streamState: "idle",
    notFound: false,
    activeTab: "output",
    live: {
      streamAbort: null,
      snapshotTimer: null
    },
    requests: {
      snapshot: createRequestCoordinator(),
      artifactBody: createRequestCoordinator()
    }
  };
}

export function chooseTurnDetailArtifactID(currentID, items) {
  if (currentID && items.some((item) => item.id === currentID)) {
    return currentID;
  }
  return items.length ? items[0].id : "";
}

export function renderTurnArtifactBody(state) {
  const artifact = selectedTurnArtifact(state);
  if (!artifact) {
    return "No artifact selected.";
  }
  if (state.artifactBody) {
    return state.artifactBody;
  }
  if (state.artifactError) {
    return state.artifactError;
  }
  if (artifact.preview_text) {
    return artifact.preview_text;
  }
  if (artifact.storage_path) {
    return "Use the button above to load the full body.";
  }
  return "This artifact stores metadata only.";
}

export function needsTurnDetailSnapshotRefresh(eventType) {
  return eventType === "turn.started" ||
    eventType === "turn.completed" ||
    eventType === "turn.failed" ||
    eventType === "turn.canceled" ||
    eventType === "turn.artifact" ||
    eventType === "turn.diff" ||
    eventType === "turn.decision.requested" ||
    eventType === "turn.decision.updated" ||
    eventType === "turn.decision.resolved" ||
    eventType === "turn.decision.expired" ||
    eventType === "turn.decision.failed";
}

function selectedTurnArtifact(state) {
  return state.artifacts.find((item) => item.id === state.selectedArtifactID) || null;
}
